import usePresentPage, { selectors } from 'client/hooks/usePresentPage'
import { localeNames } from 'common/components/entities/LanguageSwitcher'
import React from 'react'
import { CheckboxNew } from 'src/editor/shared/ui-lib/checkbox-new'

type LanguageCheckBoxProps = {
  update: (excludeLanguagesList: string[]) => void
  excludeLanguagesList: string[]
}

const languageList = Object.keys(localeNames)

function LanguageCheckList({
  update,
  excludeLanguagesList = [],
}: LanguageCheckBoxProps) {
  const locale = usePresentPage(selectors.getPageLocale)

  const currentLocale: string = locale === 'pt' ? 'br' : locale

  const handleLanguageExclude = (language: string) => (isExcluded: boolean) => {
    if (isExcluded) {
      update(
        excludeLanguagesList.filter(
          excludedLanguage => excludedLanguage !== language,
        ),
      )
    } else {
      update([...excludeLanguagesList, language])
    }
  }

  return (
    <>
      {languageList.map((language, key) => {
        return (
          <CheckboxNew
            key={key}
            wrapperClassName="mt-1"
            label={localeNames[language]}
            skipTranslation
            onChange={handleLanguageExclude(language)}
            checked={!excludeLanguagesList.includes(language)}
            disabled={language === currentLocale}
          />
        )
      })}
    </>
  )
}

export default LanguageCheckList
